import { flagFor } from "../../utils/currencyMeta";

/**
 * A currency's flag, or its code when we have no artwork for it.
 *
 * Only 12 of the 40 active currencies have a flag asset, so this always had to
 * degrade. It degrades to the currency code rather than to a default flag:
 * the Cards screen used to show an Australian flag beside PKR, CNY and INR
 * wallets because each component's private flag map fell back to Australia.
 * In a money app that is not a cosmetic error, it misidentifies the wallet.
 */
const CurrencyFlag = ({ currency, size = 40, className = "", style }) => {
  const src = flagFor(currency);
  const code = String(currency || "").toUpperCase();

  if (src) {
    return (
      <img
        src={src}
        alt={`${code} flag`}
        width={size}
        height={size}
        className={`rounded-circle ${className}`}
        style={{ objectFit: "cover", ...style }}
      />
    );
  }

  return (
    <span
      className={`d-inline-flex align-items-center justify-content-center rounded-circle ${className}`}
      // Sized off the badge so the code stays legible at 24px and at 48px.
      style={{
        width: size,
        height: size,
        backgroundColor: "var(--brand-dark, #0E2C24)",
        color: "#fff",
        fontSize: Math.max(9, Math.round(size * 0.3)),
        fontWeight: 600,
        letterSpacing: ".02em",
        flex: "none",
        ...style,
      }}
      aria-label={`${code} currency`}
      title={code}
    >
      {code}
    </span>
  );
};

export default CurrencyFlag;
